import styled from 'styled-components';

import { Typography } from 'src/app/components/Elements/Typography';

export const Container = styled.div`
  display: flex;

  ${props => props.theme.mediaQueries.smallDown} {
    flex-direction: column;
  }
`;

export const CourierTimeText = styled(Typography)`
  color: ${props => props.theme.colors.capsuleBlue50} !important;

  font-style: normal !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  font-size: ${props => props.theme.fontSizes.displayXL} !important;
  line-height: ${props => props.theme.space['1.25']} !important;

  padding-top: ${props => props.theme.space['1.5']} !important;
  padding-bottom: ${props => props.theme.space['5.0']} !important;

  ${props => props.theme.mediaQueries.smallDown} {
    padding-top: ${props => props.theme.space['2.0']} !important;
    padding-bottom: ${props => props.theme.space.none} !important;
    font-size: ${props => props.theme.fontSizes.headerTwo} !important;
  }
`;

export const Comma = styled(props => <CourierTimeText {...props} />)`
  ${props => props.theme.mediaQueries.smallDown} {
    display: none;
  }
`;

export const MailTimeText = styled(Typography)`
  color: ${props => props.theme.colors.capsuleBlue50} !important;

  font-style: normal !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  font-size: ${props => props.theme.fontSizes.displayXL} !important;
  line-height: ${props => props.theme.space['1.25']} !important;

  padding-top: ${props => props.theme.space['1.5']} !important;
  padding-bottom: ${props => props.theme.space['5.0']} !important;
`;
